import LegalLayout from "@/components/legal/LegalLayout";
import Seo from "@/components/Seo";
import { LEGAL_NAME, TRADING_NAME, WEBSITE } from "@/constants/company";

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy"
        description={`How ${TRADING_NAME} collects, uses, and protects your personal data under UK GDPR.`}
        path="/privacy"
      />
      <LegalLayout title="Privacy Policy" subtitle="Last updated: January 2025">
      <section className="space-y-8 not-prose">
        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">1. Introduction</h2>
          <p className="mb-3 text-base leading-relaxed text-[#2A2A33]">
            {LEGAL_NAME} (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;) is committed to protecting your privacy.
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit
            our website <strong className="font-semibold text-ink">{WEBSITE}</strong> and use our solar assessment platform.
          </p>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            By using our services, you agree to the collection and use of information in accordance with this policy.
          </p>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">2. Information We Collect</h2>
          <h3 className="mb-2 text-base font-bold text-ink">2.1 Personal Information</h3>
          <ul className="mb-4 list-disc space-y-2 pl-6 text-base leading-relaxed text-[#2A2A33]">
            <li>Name, email address, phone number</li>
            <li>Property address and postcode</li>
            <li>Energy usage data (from uploaded bills or manual input)</li>
            <li>Payment information (processed securely by third-party providers)</li>
          </ul>
          <h3 className="mb-2 text-base font-bold text-ink">2.2 Automatically Collected Information</h3>
          <ul className="list-disc space-y-2 pl-6 text-base leading-relaxed text-[#2A2A33]">
            <li>IP address and browser type</li>
            <li>Device information and operating system</li>
            <li>Pages visited, time spent, and referring URLs</li>
            <li>Cookies and similar tracking technologies (see our <a href="/cookies" className="font-semibold text-indigo hover:underline">Cookie Policy</a>)</li>
          </ul>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">3. How We Use Your Information</h2>
          <ul className="list-disc space-y-2 pl-6 text-base leading-relaxed text-[#2A2A33]">
            <li>Provide personalised solar assessments and quotes</li>
            <li>Connect you with MCS-certified solar installers</li>
            <li>Process payments and manage your account</li>
            <li>Improve our platform through analytics and user feedback</li>
            <li>Send marketing communications (with your consent)</li>
            <li>Comply with legal obligations and prevent fraud</li>
          </ul>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">4. Sharing Your Information</h2>
          <p className="mb-3 text-base leading-relaxed text-[#2A2A33]">
            We do not sell your personal information. We may share your data with MCS-certified installers
            (when you request a quote) and trusted service providers for payment processing, communications,
            cloud hosting, and analytics.
          </p>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">5. Data Security</h2>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            We implement industry-standard security measures including encryption, secure servers, and access controls.
            Contact us at{" "}
            <a href="mailto:privacy@powlo.co" className="font-semibold text-indigo hover:underline">privacy@powlo.co</a>{" "}
            if you suspect unauthorised access.
          </p>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">6. Your Rights (GDPR)</h2>
          <p className="mb-2 text-base leading-relaxed text-[#2A2A33]">Under UK GDPR, you have the right to:</p>
          <ul className="list-disc space-y-2 pl-6 text-base leading-relaxed text-[#2A2A33]">
            <li>Access, rectify, or erase your personal data</li>
            <li>Restrict or object to processing</li>
            <li>Data portability</li>
            <li>Withdraw consent at any time</li>
          </ul>
          <p className="mt-3 text-base leading-relaxed text-[#2A2A33]">
            To exercise these rights, contact{" "}
            <a href="mailto:privacy@powlo.co" className="font-semibold text-indigo hover:underline">privacy@powlo.co</a>.
          </p>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">7. Contact</h2>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            {LEGAL_NAME}<br />
            Email: <a href="mailto:privacy@powlo.co" className="font-semibold text-indigo hover:underline">privacy@powlo.co</a>
          </p>
        </div>
      </section>
    </LegalLayout>
    </>
  );
}
